import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';

const MetricCard = ({ title, value, unit, color }) => (
	<Card className='shadow-sm mb-3 card-border'>
		<Card.Body className='text-center py-3'>
			<Card.Text className='text-muted mb-1' style={{ fontSize: '0.85rem' }}>{title}</Card.Text>
			<h3 style={{ color: color || '#333', marginBottom: 0 }}>
				{typeof value === 'number' ? value.toLocaleString('es-MX', { maximumFractionDigits: 1 }) : value || '—'}
			</h3>
			{unit && <small className='text-muted'>{unit}</small>}
		</Card.Body>
	</Card>
);

const StatsBatchesAnalysis = ({ data }) => {
	if (!data || !data.batch_analysis) {
		return <p className='text-center text-muted mt-3'>No batch data available</p>;
	}

	const { batch_analysis, concurrency, recent_batches } = data;

	const batchChartData = (recent_batches || []).map((batch, idx) => ({
		batch: `#${idx + 1}`,
		size: batch.size || 0,
		duration: batch.duration_seconds || 0
	}));

	return (
		<>
			<Row className='mt-3'>
				<Col xs={6} md={3}>
					<MetricCard title='Total Batches' value={batch_analysis.total_batches} color='#0d6efd' />
				</Col>
				<Col xs={6} md={3}>
					<MetricCard title='Avg Batch Size' value={batch_analysis.avg_batch_size} color='#198754' />
				</Col>
				<Col xs={6} md={3}>
					<MetricCard title='Max Batch Size' value={batch_analysis.max_batch_size} color='#fd7e14' />
				</Col>
				<Col xs={6} md={3}>
					<MetricCard title='Peak Concurrent' value={concurrency?.peak_concurrent} color='#dc3545' />
				</Col>
			</Row>
			<Row>
				<Col xs={6} md={4}>
					<MetricCard title='Avg Frequency' value={batch_analysis.avg_batch_frequency_seconds} unit='s' color='#6c757d' />
				</Col>
				<Col xs={6} md={4}>
					<MetricCard title='Avg Idle Between' value={batch_analysis.avg_inter_batch_idle_seconds} unit='s' color='#6c757d' />
				</Col>
				<Col xs={6} md={4}>
					<MetricCard title='Batch Window' value={batch_analysis.batch_window_seconds} unit='s' color='#6c757d' />
				</Col>
			</Row>

			{batchChartData.length > 0 &&
				<>
					<h6 className='text-center mt-3'>Recent Batches (size)</h6>
					<ResponsiveContainer width='100%' height={250}>
						<BarChart data={batchChartData} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
							<CartesianGrid strokeDasharray='3 3' />
							<XAxis dataKey='batch' fontSize={11} />
							<YAxis />
							<Tooltip />
							<Bar dataKey='size' fill='#0d6efd' name='Batch Size' />
						</BarChart>
					</ResponsiveContainer>
				</>
			}
		</>
	);
}

StatsBatchesAnalysis.propTypes = {
	data: PropTypes.object
}

export default StatsBatchesAnalysis;
